var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "11.111px",
    height: "13.259px",
    viewBox: "1 2.407 11.111 13.259",
    enableBackground: "new 1 2.407 11.111 13.259",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    transform: "translate(-2.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_pin",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    transform: "translate(2.667 1.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-2",
    fill: "#009AB2",
    d: "M6.556,13.333c-0.11,0-0.217-0.032-0.308-0.093 c-0.049-0.033-0.132-0.091-0.232-0.163c-0.19-0.137-0.387-0.287-0.587-0.447c-0.629-0.499-1.223-1.042-1.776-1.624 C1.892,9.149,1,7.315,1,5.555c0.041-3.068,2.562-5.522,5.63-5.481c3.01,0.04,5.441,2.471,5.481,5.481 c0,1.76-0.892,3.594-2.653,5.452c-0.554,0.582-1.147,1.125-1.776,1.624c-0.2,0.16-0.4,0.312-0.587,0.447 c-0.083,0.06-0.163,0.116-0.232,0.163C6.772,13.302,6.665,13.333,6.556,13.333z M6.556,1.111 C4.103,1.113,2.114,3.102,2.111,5.555c0,1.466,0.79,3.043,2.348,4.688c0.518,0.544,1.073,1.052,1.661,1.52 c0.153,0.121,0.3,0.233,0.435,0.334c0.143-0.105,0.289-0.219,0.436-0.334c0.588-0.469,1.143-0.976,1.661-1.52 C10.21,8.601,11,7.021,11,5.555C10.997,3.102,9.008,1.114,6.556,1.111L6.556,1.111z M6.556,7.778 c-1.228,0-2.222-0.995-2.222-2.222c0-1.228,0.995-2.222,2.222-2.222c1.227,0,2.221,0.994,2.222,2.221 C8.777,6.782,7.782,7.776,6.556,7.778L6.556,7.778z M6.556,4.444c-0.614,0-1.111,0.498-1.111,1.111 c0,0.613,0.498,1.111,1.111,1.111c0.613,0,1.111-0.498,1.111-1.111l0,0C7.667,4.941,7.169,4.444,6.556,4.444L6.556,4.444z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.2285e969173f8fa2bf8d8ed6f1cc139f.svg";
export { ForwardRef as ReactComponent };